import { Check } from '@mui/icons-material';
import { Box, Chip } from '@mui/material';

type SelectableChipProps = {
  readonly isSelected: boolean;
  readonly label: string;
  readonly onSelectChange?: (selected: boolean) => void;
};

export const SelectableChip = ({ label, isSelected, onSelectChange }: SelectableChipProps) => {
  const labelWithIcon = (
    <Box display="flex" gap={0.5} alignItems="center">
      {isSelected && <Check fontSize="small" sx={{ color: 'text.brand' }} />}
      {label}
    </Box>
  );

  return (
    <Chip
      onClick={() => onSelectChange?.(true)}
      sx={{
        borderRadius: '20px',
        py: isSelected ? '8px' : '6px',
        backgroundColor: (theme) => (isSelected ? theme.palette.surface.brandLight : theme.palette.surface.background),
        border: (theme) => (isSelected ? undefined : `1px solid ${theme.palette.border.subtle}`),
        '&:hover': {
          backgroundColor: (theme) => theme.palette.surface.brandLightHover,
          cursor: 'pointer',
        },
      }}
      label={labelWithIcon}
    />
  );
};
